import Button from "@/components/Button";
import { CSVLink } from "react-csv";
import { columnHeaders, generateColumnData } from "./utils";

/**
 * Button to trigger a CSV download of a list of Job Applicants and their reviews. This CSV is compiled client-side.
 *
 * @param {Object} params - The input parameters. All parameters have a fallback.
 * @param {Array} params.applications — An array of applicants and their reviews. Must include the applicant's first name, last name, email, phone, resume, and average score. Reviews must include score, comments, and isRecommendation.
 * @param {string} params.jobTitle — The title of the job post.
 * @param {string} params.facilityName — The name of the facility where the job is located.
 */
export default function ApplicantReviewsExportButton({
  applications = [],
  jobTitle = "Job Position",
  facilityName = "Unknown Facility"
}: any) {
  const timestamp = Date.now();
  const sanitizedJobTitle = jobTitle.trim().replace(/\s+/g, "-");
  const sanitizedFacilityName = facilityName.trim().replace(/\s+/g, "-");

  return (
    <CSVLink
      data={[columnHeaders, ...generateColumnData(applications)]}
      filename={`${sanitizedJobTitle}-${sanitizedFacilityName}-Application-Reviews-${timestamp}.csv`}
    >
      <Button icon="download" testId="export-reviews-button" variant="text">
        Export Reviews
      </Button>
    </CSVLink>
  );
}
